import DiscussControls  from './DiscussControls'
import DiscussControlsContainer  from './DiscussControlsContainer'
export default DiscussControlsContainer(DiscussControls)